import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { NeptuneApi } from '../genericApi/neptune.api';
import { TemplateApi } from './template-api.model';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { BaseAbstractApi } from '../genericApi/base-abstract.api';

@Injectable()
export class TemplateApiService extends BaseAbstractApi<TemplateApi> {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }

    getList(): Observable<TemplateApi[]> {
        const slug = '/templates';
        return this.neptuneApi.api<TemplateApi[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    getRendered(type: string, data: Record<string, unknown>): Observable<string> {
        const slug = '/templates/rendered';
        return this.neptuneApi.api<string>(
            slug,
            {type, data},
            HttpVerbsEnum.POST,
            undefined,
            'text'
        );
    }


    create(template: TemplateApi): Observable<number> {
        const slug = '/templates';

        return this.neptuneApi.api<number>(
            slug,
            template,
            HttpVerbsEnum.POST
        );
    }


    update(template: TemplateApi): Observable<null> {
        const slug = `/templates/${template.id}`;

        return this.neptuneApi.api<null>(
            slug,
            template,
            HttpVerbsEnum.PUT
        );
    }


    delete(template: TemplateApi): Observable<null> {
        const slug = `/templates/${template.id}`;

        return this.neptuneApi.api<null>(
            slug,
            null,
            HttpVerbsEnum.DELETE
        );
    }
}
